module.exports = __webpack_public_path__ + "static/media/viewBill.5072ce66.svg";